// third-party
import {FormattedMessage} from 'react-intl';


// assets
import {Book1, Code, TableDocument,} from 'iconsax-react';

// type
import {NavItemType} from 'types/menu';
import DogIcon from '../components/icon/DogIcon';
import AdoptedIcon from "../components/icon/AdoptedIcon";
import ReturnedIcon from "../components/icon/ReturnedIcon";
import BoxIcon from "../components/icon/BoxIcon";
import DeadIcon from "../components/icon/DeadIcon";
import TreatmentIcon from "../components/icon/TreatmentIcon";
import ShedIcon from "../components/icon/ShedIcon";
import UserIcon from "../components/icon/UserIcon";
import MultimediaIcon from "../components/icon/MultimediaIcon";
import CityIcon from "../components/icon/CityIcon";
import KennelsIcon from "../components/icon/KennelsIcon";

// icons
const icons = {
    page: Book1,
    table: TableDocument,
    code: Code,
    box: BoxIcon,
    adopted: AdoptedIcon,
    returned: ReturnedIcon,
    sheds: ShedIcon,
    treatments: TreatmentIcon,
    users: UserIcon,
    dead: DeadIcon,
    dog: DogIcon,
    multimedia: MultimediaIcon,
    city: CityIcon,
    kennels: KennelsIcon

};

// Definisci i ruoli dell'utente

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages: NavItemType = {
    id: 'group-pages',
    title: <FormattedMessage id="pages"/>,
    type: 'group',
    icon: icons.page,
    children: [
        {
            id: 'Adoption',
            title: <FormattedMessage id="Adopted"/>,
            type: 'item',
            url: '/Adoption',
            icon: icons.adopted,
            roles: ["ROLE_ADMIN"]
        },

        {
            id: 'Dead',
            title: <FormattedMessage id="Dead"/>,
            type: 'item',
            url: '/Dead',
            icon: icons.dead,
            roles: ["ROLE_ADMIN"]
        },

        {
            id: 'Returned',
            title: <FormattedMessage id="Returned"/>,
            type: 'item',
            url: '/Returned',
            icon: icons.returned,
            roles: ["ROLE_ADMIN"]
        },
        {
            id: 'user-super',
            title: <FormattedMessage id="users"/>,
            type: 'item',
            url: '/Utenti',
            icon: icons.users,
            roles: ["ROLE_SUPER_ADMIN"]
        },
        {
            id: 'user-admin',
            title: <FormattedMessage id="admin-users"/>,
            type: 'item',
            url: '/Utenti-admin',
            icon: icons.users,
            roles: ["ROLE_ADMIN"]

        },
        {
            id: 'shed',
            title: <FormattedMessage id="Shed"/>,
            type: 'item',
            url: '/Capannoni',
            icon: icons.sheds,
            roles: ["ROLE_ADMIN"]

        },
        {
            id: 'box',
            title: <FormattedMessage id="Box"/>,
            type: 'item',
            url: '/Box',
            icon: icons.box,
            roles: ["ROLE_ADMIN"]

        },
        {
            id: 'dog',
            title: <FormattedMessage id="Dog"/>,
            type: 'item',
            url: '/Dog',
            icon: icons.dog,
            roles: ["ROLE_ADMIN"]

        },
        {
            id: 'multimedia',
            title: <FormattedMessage id="multimedia"/>,
            type: 'item',
            url: '/Multimedia',
            icon: icons.multimedia,
            roles: ["ROLE_SUPER_ADMIN"]
        },

        {
            id: 'tenant',
            title: <FormattedMessage id="Kennels"/>,
            type: 'item',
            url: '/Tenant',
            icon: icons.kennels,
            roles: ["ROLE_SUPER_ADMIN"]

        },
        {
            id: 'Treatment',
            title: <FormattedMessage id="Expiring treatments"/>,
            type: 'item',
            url: '/Treatment',
            icon: icons.treatments,
            roles: ["ROLE_ADMIN"]
        },
        /*  {
            id: 'Dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            url: '/Dashboard',
            icon: icons.table,
            roles: ["ROLE_SUPER_ADMIN"]

          },*/
        {
            id: 'Municipality',
            title: <FormattedMessage id="Municipality"/>,
            type: 'item',
            url: '/Municipality',
            icon: icons.city,
            roles: ["ROLE_SUPER_ADMIN"]

        },
        /*
          {
            id: 'componentsOverview',
            title: <FormattedMessage id="Historic"/>,
            type: 'collapse',
            icon: icons.code,
            roles: ["ROLE_ADMIN"],

            children: [
                // shed
              {
                id:"Historic-Shed",
                title: <FormattedMessage id="Historic Shed" />,
                roles: ["ROLE_ADMIN"],
                type: 'item',
                url: '/Historic-Shed',
                icon: icons.table,

              },
                //box
              {
                id:"Historic-Box",
                title: <FormattedMessage id="Historic Box" />,
                roles: ["ROLE_ADMIN"],
                url: '/Historic-Box',
                type: 'item',
                icon: icons.table,

              },
               // dog
              {
                id:"Historic-Dog",
                title: <FormattedMessage id="Historic Dog" />,
                roles: ["ROLE_ADMIN"],
                url: '/Historic-Dog',
                type: 'item',
                icon: icons.table,
              }
            ]*/

    ]
}

const filterMenuByRole = (menu: NavItemType[], userRole: string): NavItemType[] => {
    return menu
        .filter(item => !item.roles || item.roles.includes(userRole))
        .map(item => ({
            ...item,
            children: item.children ? filterMenuByRole(item.children, userRole) : undefined,
        }));
};


export default pages;